import React from 'react';
import styled from 'styled-components';
import { rhythm } from 'Themes/typography';

const Container = styled.div`
  position: relative;
  height: 100%;
  padding: ${rhythm(0.3)} 0;
`;
const Heading = styled.h1`
  font-size: 1rem;
`;

const NotesGeneral = styled.div`
  padding: ${rhythm(0.3)} 0;
  font-family: Helvetica, Arial, sans-serif;
  padding-left: 5px;
  word-break: break-all;
`;
const NoteNumb = styled.span`
  color: black;
  font-weight: bold;
`;
const Note = styled.p`
  display: block !important;
`;

const separateNotes = note => {
  if (note) {
    // const sanitizer = dompurify.sanitize;
    // let noteSanitizer = sanitizer(note);
    let noteSanitizer = note;
    let split = noteSanitizer.split('_$_');
    return split.map((el, index) => (
      <Note key={index}>
        <NoteNumb>{index + 1 + '. '}</NoteNumb> {el}
      </Note>
    ));
  }
};
const NoteAndUrl = ({ generalNotes }) => (
  <Container>
    <React.Fragment>
      <Heading>
        <div>General notes:</div>
      </Heading>
      <NotesGeneral>{separateNotes(generalNotes)}</NotesGeneral>
    </React.Fragment>
  </Container>
);

export default NoteAndUrl;
